(ns common.languages
  (:require [clojure.string :as string]
            #?(:cljs [cljs.reader :as edn])
            #?(:clj [clojure.edn :as edn])))

;; TODO 100 most common langueges + finnish, swedish, estonian, russian, german, french, english
;; ISO 639-2, terminology code (T)
;; https://www.loc.gov/standards/iso639-2/php/code_list.php

(def languages-meta
  {:ENG {:translations {:en "English"}}
   :FIN {:translations {:en "Finnish"}}
   :SWE {:translations {:en "Swedish"}}
   :EST {:translations {:en "Estonian"}}
   :RUS {:translations {:en "Russian"}}
   :DEU {:translations {:en "German"}}
   :FRA {:translations {:en "French"}}
   :DAN {:translations {:en "Danish"}}
   :NOR {:translations {:en "Norwegian"}}
   :ZHO {:translations {:en "Chinese"}}
   :JPN {:translations {:en "Japanese"}}
   :LIT {:translations {:en "Lithuanian"}}
   :LAV {:translations {:en "Latvian"}}
   :POL {:translations {:en "Polish"}}
   :SPA {:translations {:en "Spanish"}}
   :POR {:translations {:en "Portuguese"}}})

(def short->long
  {:fi :FIN
   :en :ENG
   :de :DEU
   :se :SWE
   :ee :EST
   :ru :RUS
   :fr :FRA
   :dk :DAN
   :no :NOR
   :zh :ZHO
   :ja :JPN
   :lt :LIT
   :lv :LAV
   :pl :POL
   :es :SPA
   :pt :POR})
(def long->short
  (->> short->long
       (map (fn [[k v]]
              [v k]))
       (into {})))

(def options
  (->> languages-meta
       (map (fn [[c language-meta]]
              {:key     c
               :value   c
               :keyword c
               :label   (->> language-meta
                             :translations
                             :en)}))
       (sort-by :label)))

(defn get-label
  [cc]
  (let [cc (get short->long cc cc)]
    (get-in languages-meta [cc :translations :en])))

(defn get-local-label
  [cc]
  (let [cc-kw (cond (keyword? cc)
                    cc
                    (and (string? cc)
                         (string/starts-with? cc ":"))
                    (edn/read-string cc)
                    (string? cc)
                    (keyword cc)
                    :else
                    (keyword cc))]
    (case cc-kw
      :ENG "English"
      :FIN "Suomi"
      :SWE "Svenska"
      :EST "Eesti"
      :RUS "Русский"
      :DEU "Deutsch"
      :FRA "Français"
      :DAN "Dansk"
      :NOR "Norsk"
      :ZHO "中文"
      :JPN "日本語"
      :LIT "Lietuvių"
      :LAV "Latviešu"
      :POL "Polski"
      :SPA "Español"
      :POR "Português"
      (name cc))))

(defn get-localized-label
  [cc lang-kw]
  (let [cc (get short->long cc cc)]
    (get-in languages-meta [cc :translations (get long->short cc cc)])))

(defn get-options
  ([lang-kws]
   (get-options lang-kws :id))
  ([lang-kws value-kw]
   (->> lang-kws
        (map (fn [k]
               {value-kw k
                :label   (get-label k)}))
        (sort-by :label))))
